/* eslint-disable react/require-default-props */
import React, { useEffect, useRef } from 'react';
import Player from '@vimeo/player';
import { Container } from './styles';

interface AcademyPlayerProps {
  src: string;
  title?: string;
  autoplay?: boolean;
  muted?: boolean;
  /** Chamado quando o vídeo chega ao fim. Só funciona com o player do Vimeo. */
  onEnded?: () => void;
}

// Dos players incorporados, só o do Vimeo avisa a página quando o vídeo termina.
export const canDetectVideoEnd = (src: string): boolean =>
  src.startsWith('https://player.vimeo.com/');

const AcademyPlayer: React.FC<AcademyPlayerProps> = ({
  src,
  title = 'Transmissão ConLicitação Academy',
  autoplay = false,
  muted = false,
  onEnded,
}) => {
  const iframeRef = useRef<HTMLIFrameElement>(null);
  const params: string[] = [];
  if (autoplay) params.push('autoplay=1');
  if (muted) params.push('mute=1');
  const url = params.length ? `${src}${src.includes('?') ? '&' : '?'}${params.join('&')}` : src;

  useEffect(() => {
    if (!onEnded || !iframeRef.current || !canDetectVideoEnd(url)) return undefined;

    const player = new Player(iframeRef.current);
    player.on('ended', onEnded);

    return () => {
      player.off('ended', onEnded);
    };
  }, [url, onEnded]);

  return (
    <Container>
      <iframe
        ref={iframeRef}
        src={url}
        title={title}
        allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture; fullscreen"
        allowFullScreen
      />
    </Container>
  );
};

export default AcademyPlayer;
